import React from "react";
import { observer } from "mobx-react";
import { Paper, Typography } from "../../../../../common/components/libs";
import { Button } from "@material-ui/core";
import { OrganizationBranchClientDetails } from "../../../../../services/clients/models";
import { useHistory } from "react-router";
import { convertDate } from "../../../../../common/libs";
import {Trans, useTranslation} from "react-i18next";

const ClientCard = ({ client }: { client: OrganizationBranchClientDetails }) => {
    const history = useHistory();
    const {i18n, t} = useTranslation(["general", "clients"]);
    const locale = i18n.language;


    return <>
        <Paper p={5} style={{ maxWidth: 400, width: "100%" }}>
            <Typography variant={"h6"}>
                id
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5 }}>
                {client.id}
            </Typography>


            <Typography variant={"h6"} style={{ marginTop: 20 }}>
                {t("clients:timeCreation")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5 }}>
                {convertDate(client.createdAt)}
            </Typography>
            <Typography variant={"h6"} style={{ marginTop: 20 }}>
                {t("clients:ordersAmount")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5 }}>
                {client.totalOrders}
            </Typography>
            <Button
                color="primary"
                style={{ marginTop: 10 }}
                onClick={() => {
                    history.push(`/clients/orders/${client.id}`);
                }}
            >
                {t("clients:toOrders")}
            </Button>
        </Paper>
    </>;
};

export default observer(ClientCard);
